import React from "react";
import { useLocation } from "react-router-dom";
import AddNodeForm from "../components/NodeItem/AddNodeForm";
import { hashPassword } from "../modules/hashPassword";

const CreateThreadPage = ({ userId }) => {
  const location = useLocation();
  const resumeData = location.state || {};

  const {
    storyId,
    parentId,
    previousContent,
    category,
    title,
    threadType,
    voteMethod,
    voteTime,
    password,
    firstNodeId,
  } = resumeData;

  const [initialData, setInitialData] = React.useState(null);

  React.useEffect(() => {
    const prepare = async () => {
      const hashedPassword =
        password && password.trim() !== "" ? await hashPassword(password) : null;

      setInitialData({
        parentId,
        storyId,
        previousContent,
        category: category || "",
        title: title || "",
        threadType: threadType || "story",
        voteMethod: voteMethod || "author",
        voteTime: voteTime || 1,
        firstNodeId: firstNodeId || parentId,
        parentNodeId: parentId,
        password: hashedPassword,
      });
    };

    prepare();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, parentId, storyId, previousContent, category, title, threadType, voteMethod, voteTime, firstNodeId]);

  if (!initialData) return <div>ロード中...</div>;

  return (
    <div>
      <h1>新規スレッド作成</h1>
      {storyId ? (
        <p>
          再開元ストーリー: <strong>{storyId}</strong>
          <br />
          再開ノード: <strong>{parentId}</strong>
        </p>
      ) : (
        <p>新しいストーリーを作成します。</p>
      )}

      <AddNodeForm userId={userId} initialData={initialData} />
    </div>
  );
};

export default CreateThreadPage;
